module.exports = __webpack_public_path__ + "static/media/chameleon_banner_2.ac86ae33.jpg";